import styledC from 'styled-components';

import TextInput from '@adsk/alloy-react-text-input';

export const Input: typeof TextInput = styledC(TextInput).attrs((props) => ({
  role: 'searchbox',
  'data-testid': props['data-testid'] ?? 'SearchField__input',
}))`
  & input[type="search"] {
    padding-bottom: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  // Remove default browser clear button
  & input[type="search"]::-webkit-search-decoration, input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-results-button, input[type="search"]::-webkit-search-results-decoration {
    display: none;
  }
`;
